var $aab6d1c60b3e9a0a$exports = {};
function $aab6d1c60b3e9a0a$var$addLocalPath(path) {
    if (window.location.host === 'localhost:1234') return path;
    return path + '.html';
}
function $aab6d1c60b3e9a0a$var$getLangLink(pageName) {
    const pagePath = window.location.pathname;
    const partToPaste = pagePath.includes('ru') ? 'ru' : pagePath.includes('en') ? 'en' : '';
    if (!partToPaste) return $aab6d1c60b3e9a0a$var$addLocalPath(`./${pageName}`);
    return $aab6d1c60b3e9a0a$var$addLocalPath(`./${partToPaste}-${pageName}`);
}
function $aab6d1c60b3e9a0a$var$redirectToPage(pageName) {
    document.location.href = $aab6d1c60b3e9a0a$var$getLangLink(pageName);
}
function $aab6d1c60b3e9a0a$var$goToTri() {
    $aab6d1c60b3e9a0a$var$redirectToPage('triathlon');
}
function $aab6d1c60b3e9a0a$var$goToRun() {
    $aab6d1c60b3e9a0a$var$redirectToPage('run');
}
const $aab6d1c60b3e9a0a$var$triThumb = document.querySelector('.tri-link');
const $aab6d1c60b3e9a0a$var$runThumb = document.querySelector('.run-link');
const $aab6d1c60b3e9a0a$var$heroBlock = document.querySelector('.hero');
const $aab6d1c60b3e9a0a$var$arrowsBlock = document.querySelector('.hero__choose');
let $aab6d1c60b3e9a0a$var$scalePlus = 50;
let $aab6d1c60b3e9a0a$var$scaleMinus = 50;
if (window.screen.width <= 768) {
    const screenHight = document.documentElement.clientHeight;
    let neededHeightForRedirect = (screenHight - 72) * 0.9; //90% of client height - header
    const basicBlockHeight = (screenHight - 72) / 2;
    const endFnc = (e)=>{
        let thumbTri = $aab6d1c60b3e9a0a$var$triThumb.getBoundingClientRect();
        let thumbRun = $aab6d1c60b3e9a0a$var$runThumb.getBoundingClientRect();
        if (thumbTri.height > thumbRun.height) $aab6d1c60b3e9a0a$var$goToTri();
        else if (thumbRun.height > thumbTri.height) $aab6d1c60b3e9a0a$var$goToRun();
        else console.log(e.target);
        $aab6d1c60b3e9a0a$var$triThumb.style.height = null;
        $aab6d1c60b3e9a0a$var$runThumb.style.height = null;
        $aab6d1c60b3e9a0a$var$arrowsBlock.style = null;
        return;
    };
    $aab6d1c60b3e9a0a$var$heroBlock.addEventListener('touchstart', ()=>{
        $aab6d1c60b3e9a0a$var$heroBlock.addEventListener('touchend', endFnc);
    }, true);
    let startY;
    let arrowBasicY;
    $aab6d1c60b3e9a0a$var$heroBlock.addEventListener('touchstart', (e)=>{
        startY = e.touches[0].clientY;
        arrowBasicY = $aab6d1c60b3e9a0a$var$arrowsBlock.getBoundingClientRect().y;
    }, true);
    $aab6d1c60b3e9a0a$var$heroBlock.addEventListener('touchmove', (e)=>{
        let currentY = e.touches[0].clientY;
        let difference = currentY - startY;
        $aab6d1c60b3e9a0a$var$triThumb.style.height = `${basicBlockHeight + difference}px`;
        $aab6d1c60b3e9a0a$var$runThumb.style.height = `${basicBlockHeight - difference}px`;
        $aab6d1c60b3e9a0a$var$arrowsBlock.style.top = `${arrowBasicY + difference + 7}px`;
    }, true);
    $aab6d1c60b3e9a0a$var$triThumb.addEventListener('click', $aab6d1c60b3e9a0a$var$goToTri);
    $aab6d1c60b3e9a0a$var$runThumb.addEventListener('click', $aab6d1c60b3e9a0a$var$goToRun);
} else {
    $aab6d1c60b3e9a0a$var$triThumb.addEventListener('click', $aab6d1c60b3e9a0a$var$goToTri);
    $aab6d1c60b3e9a0a$var$runThumb.addEventListener('click', $aab6d1c60b3e9a0a$var$goToRun);
}


//# sourceMappingURL=en.45a7a1c0.js.map
